/**
 * Helper for identifying per-org support users: DB-only users
 * (support+<org_name_slug>@tenzo.ai) provisioned in each org as impersonation
 * targets for the global support account. They can never log in directly.
 */

const ORG_SUPPORT_EMAIL_REGEX = /^support\+[a-z0-9][a-z0-9-]*@tenzo\.ai$/i;

export const isOrgSupportUserEmail = (
  email: string | null | undefined
): boolean => !!email && ORG_SUPPORT_EMAIL_REGEX.test(email.trim());

// Global support logins; must match SUPPORT_EMAILS in server/auth/support_user_mode.py.
const SUPPORT_LOGIN_EMAILS = new Set(['support@salv.ai', 'support@tenzo.ai']);

export const isSupportLoginEmail = (
  email: string | null | undefined
): boolean => !!email && SUPPORT_LOGIN_EMAILS.has(email.trim().toLowerCase());
